import { BreadcrumbProps } from '../../types';

const getCategoriesIds = ({ breadcrumb }: BreadcrumbProps) => {
  const arr = Array.isArray(breadcrumb) ? [...breadcrumb] : [];
  const arrCategoriesId: string[] = arr?.map(({ id }) => id);

  return arrCategoriesId;
};

export default getCategoriesIds;
export { getCategoriesIds };
